import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Page = styled.div`
  padding: 0 ${rem(32)};
`;
